import { SearchX } from 'lucide-react'

import StatusScreen from '@/custolink-newdesign/components/StatusScreen'

/**
 * 404, new design - the catch-all for unmatched paths under "/" and "/admin"
 * (OrganisationAllRoutes.tsx). Same constraint as ErrorPage.tsx: no
 * useUiContext, no org data, renders standalone - see StatusScreen.tsx.
 */
export default function NotFoundPageNewDesign() {
  const homeHref = window.location.pathname.startsWith('/admin') ? '/admin' : '/'

  return (
    <StatusScreen
      fullPage
      tone="neutral"
      icon={<SearchX className="cl:size-6" />}
      title="Page not found"
      description="The page you are looking for does not exist, or may have moved."
      primaryLabel="Go to start"
      secondaryLabel="Back"
      onPrimary={() => {
        window.location.href = homeHref
      }}
      onSecondary={() => window.history.back()}
    />
  )
}
